
export class Accesibilidad {

    public contrasteDefault: string; // contraste  por defecto
    public tiempoMensajes: string; // true or false para mostrar cambio ed tamaño de letra
    public lenguajeSenias: string; // true or false para mostrar dropdown de cambio de idioma
    public tecladoVirtual: string; // true or false para mos
    public tiempoReversibilidad: string; // true or false para mos
    public tamanioLetra: string;

    public tiempoMensajesNumber: number;
    public lenguajeSeniasBoolean: boolean;
    public tecladoVirtualBoolean: boolean;
    public tiempoReversibilidadNumeric: number;
    public tamanioLetraNumber: number;
    public contrasteTema:string;




}
